<p-dialog [modal]="true" [(visible)]="visible" [closable]="false" [style]="{ width: '250px', height: '250px' }">
  <div class="flex width-100 column" style="padding: 1rem; justify-content: center; align-items: center;">
    <div class="text-title" style="font-size: 2rem;">Saving</div>
    <p-progressSpinner strokeWidth="4" animationDuration=".5s"/>
  </div>
</p-dialog>
